import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("rect", {
  x: "3",
  y: "4",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2"
}), ___EmotionJSX("line", {
  x1: "16",
  y1: "2",
  x2: "16",
  y2: "6"
}), ___EmotionJSX("line", {
  x1: "8",
  y1: "2",
  x2: "8",
  y2: "6"
}), ___EmotionJSX("line", {
  x1: "3",
  y1: "10",
  x2: "21",
  y2: "10"
}));
export default SVG;